export class NativeStreamStructTransformColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "expr",
            "baseName": "expr",
            "type": "string",
            "format": ""
        },
        {
            "name": "overwrite",
            "baseName": "overwrite",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamStructOutputKind",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<NativeStreamOutputField>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamStructTransformColumn.attributeTypeMap;
    }
    constructor() {
    }
}
